/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatfocuslabel2Inputs */

const en_formatfocuslabel2 = /** @type {(inputs: Formatfocuslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What should stand out?`)
};

const de_formatfocuslabel2 = /** @type {(inputs: Formatfocuslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was soll im Vordergrund stehen?`)
};

/**
* | output |
* | --- |
* | "What should stand out?" |
*
* @param {Formatfocuslabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const formatfocuslabel2 = /** @type {((inputs?: Formatfocuslabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatfocuslabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatfocuslabel2(inputs)
	return de_formatfocuslabel2(inputs)
});
export { formatfocuslabel2 as "formatFocusLabel" }